(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["be-refined-home"] && !Shopify.designMode) return;
  try {
    
  function setupCableBrowser(root) {
    if (root.dataset.inlineReady) return;
    root.dataset.inlineReady = 'true';
    const panel = root.querySelector('.be-inline-results');
    const results = root.querySelector('[data-be-results]');
    const status = root.querySelector('[data-be-status]');
    const title = root.querySelector('[data-be-title]');
    const popular = root.querySelector('.be-compact__featured');
    const links = [...root.querySelectorAll('[data-be-category]')];
    let active = null;
    let controller = null;
    const close = () => {
      controller?.abort();
      panel.hidden = true;
      if (popular) popular.hidden = false;
      links.forEach(link => link.setAttribute('aria-expanded', 'false'));
      active?.focus();
      active = null;
    };
    async function show(url, link, pagination = false) {
      controller?.abort();
      controller = new AbortController();
      const request = controller;
      active = link;
      links.forEach(item => item.setAttribute('aria-expanded', String(item === link)));
      panel.hidden = false;
      if (popular) popular.hidden = true;
      title.textContent = link.textContent.trim();
      status.textContent = 'Loading products…';
      results.replaceChildren();
      panel.setAttribute('aria-busy', 'true');
      try {
        const target = new URL(url, location.origin);
        if (target.pathname.endsWith('/search')) {
          const query = target.searchParams.get('q') || '';
          if (!query.startsWith('title:')) target.searchParams.set('q', 'title:' + query);
        }
        target.searchParams.set('section_id', 'be-inline-products');
        const response = await fetch(target, {signal: request.signal});
        if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-be-product-results]');
        if (!content) throw new Error('Missing results');
        if (request.signal.aborted) return;
        results.append(content);
        status.textContent = content.dataset.count + ' products';
        if (pagination) title.focus({preventScroll:true});
      } catch (error) {
        if (error.name === 'AbortError') return;
        status.textContent = 'Products could not load. Try again or open this category.';
        const fallback = document.createElement('a');
        fallback.href = url;
        fallback.textContent = 'Open category';
        results.append(fallback);
      } finally {
        if (!request.signal.aborted) panel.removeAttribute('aria-busy');
      }
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-be-category]');
      if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        if (active === link && !panel.hidden) close();
        else show(link.href, link);
      }
      const page = event.target.closest('[data-be-pagination] a');
      if (page && active) { event.preventDefault(); show(page.href, active, true); }
      if (event.target.closest('[data-be-close]')) close();
    });
    panel.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  }
  document.querySelectorAll('.be-compact').forEach(setupCableBrowser);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.be-compact').forEach(setupCableBrowser));

  function setupQuickBuy(root) {
    if (root.dataset.quickReady) return;
    root.dataset.quickReady = 'true';
    root.addEventListener('change', event => {
      if (!event.target.matches('.be-quick select[name="id"]')) return;
      const form = event.target.closest('form');
      const option = event.target.selectedOptions[0];
      const quantity = form.elements.quantity;
      form.querySelector('[data-quick-price]').textContent = option.dataset.price;
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      if (!quantity.checkValidity()) quantity.value = quantity.min;
      const button = form.querySelector('button[type="submit"]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? form.dataset.soldLabel : form.dataset.addLabel;
      form.querySelector('[role="status"]').textContent = '';
      const image = form.closest('article').querySelector('.be-compact__product-media img');
      if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    });
    root.addEventListener('submit', async event => {
      const form = event.target.closest('.be-quick');
      if (!form) return;
      event.preventDefault();
      if (root.dataset.cartBusy || !form.reportValidity()) return;
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled) return;
      const status = form.querySelector('[role="status"]');
      const cartLink = form.querySelector('.be-quick__cart');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const select = form.elements.id;
      const quantity = form.elements.quantity;
      const payload = {id:select.value,quantity:Number(quantity.value)};
      if (cart?.getSectionsToRender) {
        payload.sections = cart.getSectionsToRender().map(section => section.id);
        payload.sections_url = location.pathname;
        cart.setActiveElement?.(button);
      }
      root.dataset.cartBusy = 'true';
      button.disabled = true; select.disabled = true; quantity.disabled = true;
      button.textContent = form.dataset.addingLabel;
      status.textContent = '';
      let added = false;
      try {
        const response = await fetch(form.action + '.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const data = await response.json();
        if (!response.ok || data.status) {
          status.textContent = typeof data.description === 'string' ? data.description : form.dataset.errorLabel;
          cartLink.hidden = false;
          return;
        }
        added = true;
        status.textContent = form.dataset.addedLabel;
        cartLink.hidden = false;
        if (cart && payload.sections?.every(id => data.sections?.[id])) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        }
      } catch (error) {
        if (!added) status.textContent = form.dataset.errorLabel;
        cartLink.hidden = false;
      } finally {
        delete root.dataset.cartBusy;
        select.disabled = false; quantity.disabled = false;
        button.disabled = select.selectedOptions[0].dataset.available !== 'true';
        button.textContent = button.disabled ? form.dataset.soldLabel : form.dataset.addLabel;
      }
    });
  }
  document.querySelectorAll('.be-compact').forEach(setupQuickBuy);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.be-compact').forEach(setupQuickBuy));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
